export const TEST_ID = 'shapefileDropZone';

export const FILE_INPUT_TEST_ID = 'shapefileDropZoneFileInput';

export const TRIGGER_BUTTON_TEST_ID = 'shapefileDropZoneTriggerButton';

// Browser file picker filter. Includes both the .zip bundle path and the
// individual shapefile component files so multi-select works.
export const ACCEPT_FILE_TYPES = '.shp,.shx,.dbf,.prj,.cpg,.zip';
